import React, { type ComponentProps, type ReactElement } from 'react';

import type { Placeholder as OriginalPlaceholder } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const Placeholder = ({
	allowPlaceholderText,
	text,
	lightNodeRef,
}: ComponentProps<typeof OriginalPlaceholder> & LightNodeProps): ReactElement => (
	<span ref={lightNodeRef} data-placeholder={allowPlaceholderText ? text : undefined}>
		{allowPlaceholderText ? text : undefined}
	</span>
);
